exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".mt20[data-v-6a2581aa]{margin-top:20px}.doing[data-v-6a2581aa]{color:#da0b1f;font-size:14px;line-height:15px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"id":"data-v-6a2581aa","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./vue/views/headOffice/business/flow/list.vue
// module id = 457
// module chunks = 0